import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LicensedAgent} from "../../../shared/interface/licensed-agent";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatDialog} from "@angular/material/dialog";
import {LicensedAgentService} from "../../../shared/services/licensed-agent.service";
import {FormBuilder, NgForm} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../shared/services/auth.service";
import {delay, distinctUntilChanged, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {HttpErrorResponse} from "@angular/common/http";
import {FilterService} from "../../../shared/services/filter.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {select, Store} from "@ngrx/store";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {ActivatedRoute, Router} from "@angular/router";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {
  AGENT_21_STATUS,
  AGENT_21_STATUS_APPLICATION_FOR_RENEWAL,
  AGENT_21_STATUS_CANCELLATION_OF_RENEWAL,
  AGENT_21_STATUS_IT_EXPIRES,
  AGENT_21_STATUS_PARTNER_NOTIFICATION,
  AGENT_21_STATUS_RENEWAL_INVOICE_SENT,
  DictService,
  IMPORT_STATUS_IN_PROGRESS
} from "../../../shared/services/dict.service";
import {Dictionary} from "../../../shared/interface/dictionary";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";

@Component({
  selector: 'app-all-agent-21',
  templateUrl: './all-licensed-agent.component.html',
  styleUrls: ['./all-licensed-agent.component.scss']
})
export class AllLicensedAgentComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() embeddedView = false;
  @Input() partnerId?: string = null;
  @Input() showFilter = true;

  items: LicensedAgent[] = [];
  initialFilters: any;
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  displayedColumns: string[] = ['createAt', 'status', 'payer', 'partner', 'ofwca', 'partnerRegional',
    'licenseEndDate', 'day', 'action'];

   readonly IMPORT_STATUS_IN_PROGRESS = IMPORT_STATUS_IN_PROGRESS;
   readonly AGENT_21_STATUS_CANCELLATION_OF_RENEWAL = AGENT_21_STATUS_CANCELLATION_OF_RENEWAL;
   readonly AGENT_21_STATUS_IT_EXPIRES = AGENT_21_STATUS_IT_EXPIRES;
   readonly AGENT_21_STATUS_APPLICATION_FOR_RENEWAL = AGENT_21_STATUS_APPLICATION_FOR_RENEWAL;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private licensedAgentService: LicensedAgentService,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private dialog: MatDialog,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.licensedAgentService.licensedAgentListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<LicensedAgent>) => {
          this.items = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      partner: 'string',
      gte$createdAt: 'string',
      lte$createdAt: 'string',
      in$status: 'int[]',
      payer: 'int',
      assetsRegional: 'string',
      ofwca: 'string',
      gte$expirationAt: 'string',
      lte$expirationAt: 'string',
      daysToExpiration: 'int',
      contains$licenseNip: 'string',
      contains$invoiceNip: 'string',
    }, filters);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        if (!this.embeddedView) {
          this.store
            .pipe(
              select(getCurrentRouteState),
              delay(0),
              distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
              takeUntil(this.destroyed$),
            )
            .subscribe((state: RouterStateUrl) => {
              this.parseFilters(state.params);
              this.paginator.pageIndex = state.params.page;
              this.paginator.pageSize = state.params.pageSize;
              this.loadListData();
            });
        } else {
          this.loadListData();
        }
      });
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      if (this.embeddedView) {
        this.loadListData();
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value
        })]);
      }
    });
  }

  refresh(): void {
    this.loadListData(); // <-- odświeża listę agentów, może wywoływać API
  }

  async loadListData(): Promise<void> {
    this.licensedAgentService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters()
    );
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.partnerId) {
      filters.partner = this.partnerId;
    }

    return filters;
  }

  time(time: any): string|null {
    if (time === null){
      return null;
    }
    var date =  new Date(time * 1);
    return  date.toLocaleDateString('en-GB');
  }

  day(time: any): string|null {
    if (!time) {
      return '';
    }

    const ms = 1000 * 60 * 60 * 24;

    const today = new Date().setHours(0, 0, 0, 0);
    const day = new Date(time).setHours(0, 0, 0, 0);

    const ilosc_dni = (day - today) / ms;
    return String(Math.trunc(ilosc_dni));
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
      }]);
    }

  }
  filter(): void {
    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value,
      })]);
    }
  }

  downloadReport(): void {
    this.licensedAgentService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  statusTo(statusKey: string, uuid: string): void {
    this.dictService.get(statusKey, AGENT_21_STATUS)
      .subscribe((dict: Dictionary) => {
        var textValue = '';
        if (dict.key === AGENT_21_STATUS_PARTNER_NOTIFICATION) {
          textValue = 'Zmieniając status na Powiadomienie Partnera nabywca licencji otrzyma e-mail z informacją o aktywacji licencji. Czy na pewno chcesz zmienić status?';
        } else {
          textValue = 'Czy na pewno chcesz zmienić status licencji na ' + dict.name + ' ?';

        }
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '500px',
          data: {text: textValue},
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.licensedAgentService.statusUpdate(
              uuid,
              dict.id
            ).subscribe(() => {
             this.loadListData();
              this.snack.open('Pomyślnie zmieniono status', '', {duration: 2000});
            }, (error: HttpErrorResponse) => {
              this.snack.open('Przy zmieniono status wystąpił błąd', error.status.toString(), {duration: 2000});
              if (error.status === 400) {
                this.snack.open(error.error.error.text, '400', {duration: 4000});
              }
            });
          }
        });
      });
  }
}
